import { useMemo } from 'react'
import { jornada } from 'service/api'
import { useStore } from 'store'
import { diarioColumns, mensalColumns } from '../columns'
import TodosToolbar from '../toolbar/todos-toolbar'
import { useDigitacaoStore } from '../utils/store'
import { DigitacaoSubPages } from './DigitacaoSubPages'
import { useDigitacaoContext } from './useDigitacaoContext'

export default function DigitacaoTodosPage() {
    const {
        view,
        periodo: [dataInicial, dataFinal],
    } = useDigitacaoContext()
    const funcionarioId = useStore(state => state.employeeId)
    const empresaId = useStore(state => state.companyId)
    const empresa = useStore(state => state.company)
    const organizacao = useDigitacaoStore(state => state.organizacao)

    const {
        data: mensal,
        isFetching: isLoadingMensal,
        error: mensalError,
        isError: isErrorMensal,
    } = jornada.mensal.useFetch({
        queryParams: {
            dataInicial,
            dataFinal,
            funcionarioId,
            organizar: view === 'mensal' && organizacao === 'jornada',
        },
        enabled: funcionarioId > 0 && view === 'mensal',
    })

    const {
        data: diario,
        isFetching: isLoadingDiario,
        error: diarioError,
        isError: isErrorDiario,
    } = jornada.diaria.useFetch({
        queryParams: {
            dia: dataInicial,
            empresaId,
        },
        enabled: funcionarioId > 0 && view === 'diario',
    })

    const columns = useMemo(
        () =>
            view === 'mensal'
                ? mensalColumns(empresa?.exibirSaldoDiario == 'S')
                : diarioColumns,
        [view, empresa?.exibirSaldoDiario],
    )

    return (
        <DigitacaoSubPages
            Toolbar={TodosToolbar}
            columns={columns}
            dataDiario={diario}
            dataMensal={mensal}
            diarioError={diarioError}
            mensalError={mensalError}
            isErrorDiario={isErrorDiario}
            isErrorMensal={isErrorMensal}
            isLoadingDiario={isLoadingDiario}
            isLoadingMensal={isLoadingMensal}
        />
    )
}
